import { render } from "./WindowResize.vue?vue&type=template&id=188d133e&ts=true"
import script from "./WindowResize.vue?vue&type=script&lang=ts"
export * from "./WindowResize.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-pim-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__